import {
	KSK2040_R01DetailDto,
	KSK2040_R01ValueType,
	KSK2040_R01_VALUE_FIELDS,
} from "./Dto_KSK2040_R01";

export const normalizeKSK2040_R01ValueType = (
	valueType: KSK2040_R01DetailDto["valueType"],
): KSK2040_R01ValueType | "" => {
	const normalized = String(valueType ?? "").trim().toUpperCase();
	return normalized === "NUMERIC" || normalized === "TEXT" || normalized === "PASS_FAIL"
		? normalized
		: "";
};

export const normalizeKSK2040_R01InspectionValue = (
	valueType: KSK2040_R01DetailDto["valueType"],
	value: unknown,
): string => {
	const normalized = String(value ?? "").trim();
	if (!normalized) return "";
	const type = normalizeKSK2040_R01ValueType(valueType);
	if (type === "PASS_FAIL") {
		const passFail = normalized.toUpperCase();
		if (passFail === "Y" || passFail === "O") return "Y";
		if (passFail === "N" || passFail === "X") return "N";
		return "";
	}
	return type === "NUMERIC" ? normalized.replace(/,/g, "") : normalized;
};

const createApiValue = (
	valueType: KSK2040_R01DetailDto["valueType"],
	value: unknown,
): string => {
	const normalized = normalizeKSK2040_R01InspectionValue(valueType, value);
	if (normalizeKSK2040_R01ValueType(valueType) !== "PASS_FAIL") return normalized;
	return normalized === "Y" ? "O" : normalized === "N" ? "X" : "";
};

export const normalizeKSK2040_R01InspectionDetail = (
	detail: KSK2040_R01DetailDto,
): KSK2040_R01DetailDto => ({
	...detail,
	valueType: normalizeKSK2040_R01ValueType(detail.valueType),
	...Object.fromEntries(KSK2040_R01_VALUE_FIELDS.map((field) => [
		field,
		normalizeKSK2040_R01InspectionValue(detail.valueType, detail[field]),
	])),
});

export const createKSK2040_R01SaveDetail = (
	detail: KSK2040_R01DetailDto,
): KSK2040_R01DetailDto => ({
	...detail,
	...Object.fromEntries(KSK2040_R01_VALUE_FIELDS.map((field) => [
		field,
		createApiValue(detail.valueType, detail[field]),
	])),
});

export const hasKSK2040_R01InspectionValue = (details: KSK2040_R01DetailDto[]) =>
	details.some((detail) => KSK2040_R01_VALUE_FIELDS.some((field) =>
		normalizeKSK2040_R01InspectionValue(detail.valueType, detail[field]).length > 0,
	));

export const validateKSK2040_R01InspectionValue = (detail: KSK2040_R01DetailDto) =>
	KSK2040_R01_VALUE_FIELDS.every((field) => {
		const value = normalizeKSK2040_R01InspectionValue(detail.valueType, detail[field]);
		const type = normalizeKSK2040_R01ValueType(detail.valueType);
		if (!value) return true;
		if (type === "PASS_FAIL") return value === "Y" || value === "N";
		if (type === "NUMERIC") return /^-?(?:\d+\.?\d*|\.\d+)$/.test(value);
		return type === "TEXT" && value.length <= 100;
	});
